'use client'

// React Imports
import React from 'react'

// Component Imports
import CustomerLedgerList from './Components/list'

const CustomerLedgerPage = () => {
    return (
        <div className="customer-ledger-page" style={{ height: '100%', overflow: 'auto' }}>
            <input type="hidden" id="hdnModuleCode" name="hdnModuleCode" value="PAG10274" readOnly />
            <CustomerLedgerList />
        </div>
    )
}

export default CustomerLedgerPage
